import React, {Component} from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Grid, Segment, Header, Loader } from 'semantic-ui-react';

import HradminEmployeeDetailsTable from '../../../component/hradmin/employee/details_table';

class HradminEmployeeViewDetailsPage extends Component {
    state = {
        employeeData: null
    }
    componentDidMount() {
        // console.log(this.props);
        const {uuid} = this.props.match.params;
        // console.log(uuid);
        const selectedEmployeeData = _.find(this.props.employeelistData, (employee) => employee.uuid === uuid);
        // console.log(selectedEmployeeData);
        this.setState({employeeData: selectedEmployeeData});
    }
    render() {
        if (!this.state.employeeData) { return <Loader active /> }
        return (
            <Grid columns={1}>
                <Grid.Column>
                    <Header block attached="top">
                        Employee Details
                    </Header>
                    <Segment attached>
                        <HradminEmployeeDetailsTable
                            employee={this.state.employeeData}
                        />
                    </Segment>
                </Grid.Column>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        employeelistData: state.hradmin.employeelistData,
        user: state.user.user,
    };
}

export default connect(mapStateToProps, {

})(HradminEmployeeViewDetailsPage);